export default function SiteFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-2">
          <div className="font-display text-lg font-bold tracking-tight text-[#0A2540]">
            MedAdmits
          </div>
          <p className="mt-3 max-w-md text-sm text-slate-600">
            India&rsquo;s premium scholarship gateway for MBBS abroad. Vetted
            universities. Transparent counselling. Better outcomes.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">
            Programs
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-700">
            <li>Russia</li>
            <li>Georgia</li>
            <li>Uzbekistan</li>
            <li>Kazakhstan</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">
            Company
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-700">
            <li>About</li>
            <li>Counsellors</li>
            <li>Privacy</li>
            <li>Contact</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 px-4 py-5 text-center text-xs text-slate-500">
        © 2026 MedAdmits. All rights reserved.
      </div>
    </footer>
  );
}
